import(/* webpackMode: "eager", webpackExports: ["Root","List","Item","Trigger","Content","Viewport","Link","Indicator"] */ "/home/gs/apps/client-app/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/gs/apps/client-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/public/images/service/calculated.png");
;
import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/public/images/service/matterport-service.jpg");
;
import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/public/images/service/optimized.png");
;
import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/public/images/service/prozess-aufmassservice.png");
;
import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/public/images/service/sized.png");
;
import(/* webpackMode: "eager" */ "/home/gs/apps/client-app/public/images/service/stamp.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/public/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/public/TypewriterDemo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/shared/public/carousel/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/shared/public/CustomerSwitch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/shared/public/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/shared/public/price-calculator-steps/PriceCalculatorSteps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/shared/public/PriceCalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/components/shared/public/TurnstileWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogTrigger","DialogContent","DialogHeader","DialogTitle","DialogDescription"] */ "/home/gs/apps/client-app/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/views/public/home/FeatureDescriptions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/views/public/home/HeroAdd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/views/public/home/Intro.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/views/public/home/Partners.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/views/public/home/service-details/ServiceDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/gs/apps/client-app/src/views/public/home/Testimonials.tsx");
